module.exports = __webpack_public_path__ + "img/product-2.96a2422e.jpg";